import { ToastType } from '../ui/toast/toast.model';
import { Pipe, type PipeTransform } from '@angular/core';

const ICON_MAP: Record<ToastType, string> = {
  success: 'success-icon.png',
  error: 'info.svg',
  warning: 'warning.svg',
  info: 'info.svg',
  multiline: 'success-icon.png',
  'tab-error': 'info.svg',
  'tab-warning': 'warning.svg',
  'tab-success': 'success-icon.png',
  'mobile-error': 'info.svg',
};

@Pipe({
  name: 'toastIcon',
  standalone: true,
})
export class ToastIconPipe implements PipeTransform {
  private readonly assetPath = '../../../../assets/icons/';

  transform(type: ToastType): string {
    const iconFile = ICON_MAP[type] || 'info.svg';
    return `${this.assetPath}${iconFile}`;
  }
}
